import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Timer"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.2359 1.5H9.37897V3.11897H14.2359V1.5ZM20.3722 6.02505L21.5217 7.16643L19.5061 9.18205C21.8896 13.2689 20.6397 18.5075 16.6678 21.0781C12.696 23.6486 7.40506 22.6432 4.65294 18.7949C1.90083 14.9466 2.65963 9.61474 6.37606 6.687C10.0925 3.75927 15.4539 4.26982 18.5509 7.8464L20.3722 6.02505ZM4.52244 13.6424C4.52244 17.666 7.78421 20.9277 11.8078 20.9277C15.8314 20.9277 19.0932 17.666 19.0932 13.6424C19.0932 9.61876 15.8314 6.35698 11.8078 6.35698C7.78421 6.35698 4.52244 9.61876 4.52244 13.6424ZM10.998 8.7853H12.6169V16.0707H10.998V8.7853Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Timer.vue"]]);
